import { useLocation, useNavigate } from '@thd-olt-component-react/router';

export function useCabinetSearchParams() {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);
  const base = 10;

  // key to lowercase
  const normalizeKey = (key) => key.toLowerCase();

  // Function to get a query parameter value case-insensitively
  const getQueryParam = (paramName) => {
    let result = null;
    searchParams.forEach((value, key) => {
      // Normalize both the key and paramName to lowercase for case-insensitive comparison
      if (key.toLowerCase() === normalizeKey(paramName)) {
        result = value;
      }
    });
    return result;
  };

  // Function to update or set a case-insensitive query parameter
  const updateQueryParam = (params) => {
    const newSearchParams = new URLSearchParams(search);

    Object.keys(params).forEach((paramName) => {
      // Normalize the param name to lowercase for consistency
      const normalizedParamName = normalizeKey(paramName);

      // Remove any existing case-insensitive matches for the key
      newSearchParams.forEach((key) => {
        if (normalizeKey(key) === normalizedParamName) {
          newSearchParams.delete(key);
        }
      });

      // Add the new parameter (it will always be in lowercase)
      newSearchParams.set(normalizedParamName, params[paramName]);
    });

    // Navigate with the updated search params
    navigate({
      pathname,
      search: newSearchParams.toString(),
    });
  };

  return {
    designStyleChoiceId: parseInt(getQueryParam('designStyleChoiceId') || 0, base),
    designId: getQueryParam('designId'),
    updateDesignId: (value) => updateQueryParam({ designId: value })
  };
}